import React from 'react';
import { PostResponseSchema } from '@/api/client';
import { EventMarkerSvg } from './EventMarkerSvg';
import { LiveMarkerSvg } from './LiveMarkerSvg';
import { RecordedMarkerSvg } from './RecordedMarkerSvg';
import {
  getEventBackgroundColor,
  getLivestreamBackgroundColor,
  isLivestreamReplay,
  MARKER_COLORS,
} from './markerUtils';

interface MapMarkerProps {
  post: PostResponseSchema;
}

/**
 * Orchestrator component that renders the appropriate marker type
 * based on post_type (matches React Native MapMarker pattern)
 */
export const MapMarker: React.FC<MapMarkerProps> = ({ post }) => {
  switch (post.post_type) {
    case 'event':
      return <EventMarkerSvg backgroundColor={getEventBackgroundColor(post)} />;

    case 'livestream':
      return (
        <LiveMarkerSvg
          backgroundColor={getLivestreamBackgroundColor(post)}
          isReplay={isLivestreamReplay(post)}
        />
      );

    case 'recorded':
    default:
      return (
        <RecordedMarkerSvg
          iconName={post.icon || 'headphones'}
          backgroundColor={MARKER_COLORS.recorded}
          isHighlighted={false}
        />
      );
  }
};
